<!--
 * @Author: your name
 * @Date: 2020-11-18 20:20:46
 * @LastEditTime: 2020-12-31 18:10:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/cart/component/TipContent/index.vue
-->
<style scoped lang="sass">
$defaultBorderColor: #e2e2e2
$defaultBgc: #f8f8f8
$defaultNextButtonBgc: #c4c6c7
$textColor: #fff

.tip_content
  display: flex
  flex-direction: column
  justify-content: space-between
  height: 100%

.title
  line-height: 20PX
  text-align: center
  font-size: 17PX
  margin-bottom: 25PX
  margin-top: 5PX

.tip_percent
  display: flex
  justify-content: space-between
  align-items: center

.no_tip_button
  margin: 18PX 0
  font-size: 15PX
  border: 1PX solid $defaultBorderColor
  color: var(--menu-primary-text-colour)
  background-color: $defaultBgc !important

.next_button
  font-size: 15PX
  color: $textColor
  background-color: $defaultNextButtonBgc !important

.tip_body
  flex: 1
  display: flex
  flex-direction: column
  justify-content: space-between

.active_button
  background-color: var(--menu-primary-background-colour) !important

::v-deep
  .van-button--disabled
    opacity: 1
</style>

<template lang="pug">
.tip_content
  .title.b {{ t('would_you_like_to_add_tip', 'Would you like to add a tip?') }}
  .tip_body
    .tip_percent
      tip-percent-box.p(
        v-for="(item, index) in priceList"
        :key="item.id"
        :percent-num="item.percentNum"
        :money="item.money"
        :index="index"
        :activeIndex.sync="activeIndex"
        v-on="$listeners"
      )
    van-button.no_tip_button.ls1.b(
      type="primary"
      size="large"
      @click="closeDialog"
    ) {{ t('no_tip', 'NO TIP') }}
    van-button.next_button.ls1.b(
      type="primary"
      size="large"
      :class="{'active_button': !disabledNextButton}"
      :disabled="disabledNextButton"
      @click="clickNextButton"
    ) {{ t('next', 'NEXT') }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import TipPercentBox from '../TipPercentBox'
import { formatDecimalNumber } from '@/utils/currency'
import { tipAmountFor } from '@/utils/feeChain'
import { t } from '@/utils/language'

@Component({
  components: {
    TipPercentBox
  },

  props: {
    disabledNextButton: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number
    },
    percentList: {
      type: Array
    }
  },

  computed: {
    priceList() {
      return this.percentList.map(item => {
        return {
          percentNum: parseInt(item * 100),
          money: formatDecimalNumber(tipAmountFor(item, this.total))
        }
      })
    }
  }

})

class TipContent extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  activeIndex = -1

  closeDialog() {
    this.$emit('closeDialog')
  }

  clickNextButton() {
    if (!this.disabledNextButton) this.$emit('clickNextButton')
  }
}

export default TipContent
</script>
